const publicPaths = {
  login: '/login',
  sendEmail: '/sendemail',
  passwordReset: '/password-reset',
  signup: '/account-signup',
};

const protectedPaths = {
  all: '/*',
  orderList: '/order-list',
  orderHistory: '/order-history',
  orderDetail: '/order-detail',
  cart: '/cart',
  delivery: '/delivery',
  orderComplete: '/order-complete',
};

export const routingPath = {
  ...publicPaths,
  ...protectedPaths,
  auth: Object.fromEntries(
    Object.entries(protectedPaths).map(([key, path]) => [key, `/auth${path}`])
  ),
  all: '*',
};
